import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import type { Admin } from '@ct-vision/shared';
import { adminAuthApi } from '@ct-vision/shared';

export const useAuthStore = defineStore('auth', () => {
  const admin = ref<Admin | null>(null);
  const accessToken = ref<string | null>(localStorage.getItem('admin_token'));
  const loading = ref(false);

  const isAuthenticated = computed(() => !!accessToken.value);
  const isSuperAdmin = computed(() => admin.value?.role === 'Super');

  const setToken = (token: string) => {
    accessToken.value = token;
    localStorage.setItem('admin_token', token);
  };

  const clearAuth = () => {
    admin.value = null;
    accessToken.value = null;
    localStorage.removeItem('admin_token');
  };

  const login = async (account: string, password: string) => {
    loading.value = true;
    try {
      console.log('开始登录:', { account, password });
      // 调用真实的管理员登录 API
      const response = await adminAuthApi.login({ account, password });
      console.log('登录响应:', response);
      
      // 保存令牌和管理员信息
      setToken(response.accessToken);
      admin.value = response.admin;
      console.log('登录成功，令牌已保存');
      
      return response;
    } catch (error: any) {
      console.error('登录失败:', error);
      // 清除认证状态
      clearAuth();
      throw error;
    } finally {
      loading.value = false;
    }
  };

  const logout = () => {
    // 先捕获 token，再清除本地状态，最后用已捕获的 token 发出 logout 请求
    const token = accessToken.value;
    clearAuth();
    if (token) {
      adminAuthApi.logoutWithToken(token).catch(() => {});
    }
  };

  return {
    admin,
    accessToken,
    loading,
    isAuthenticated,
    isSuperAdmin,
    login,
    logout,
    setToken,
    clearAuth,
  };
});
